import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dashboardData: [],
};

const DashboardSlice = createSlice({
  name: "DashboardSlice",
  initialState,
  reducers: {
    setDashboardData: (state, action) => {
      state.dashboardData = action.payload;
    },
  },
});
export const { setDashboardData: setDashboardData } = DashboardSlice.actions;

export default DashboardSlice.reducer;
